import Repository from './repository'

export default {
  postComment({ eventId, content }) {
    return Repository.post(`/v1/user/events/${eventId}/comments`, {
      comment: { content },
    })
  },
}
